import '@/themes/alemira/styles/main.scss'

import '@constructor/ui/styles/reset.css'
import '@constructor/ui/styles/globals.css'
import '@constructor/ui/styles/themes/goban.css'

import './global-styles.scss'

import '@lms/devextreme-common/assets/index.css'
import '@lms/lms-pdf-viewer/assets/index.css'
import 'react-common/assets/index.css'

import { ConfigLoader, SentryPlatforms, SvgProvider } from 'react-common'
import { Provider } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { eventBusInit } from 'apps-common'
import sprite from 'react-common/assets/sprite.svg'
import { createRoot } from 'react-dom/client'
import { PersistGate } from 'redux-persist/integration/react'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'
import { ErrorBoundaryWrapper } from '@/features/errorBoundary/ErrorBoundarWrapper'
import { CustomNavigationContextProvider } from '@/features/layout/CustomNavigationContextProvider/CustomNavigationContextProvider'
import { ROUTES } from '@/Router'
import { persistor, store } from '@/store'
import { App } from './App'
import { CombinedI18nextProvider } from './components/CombinedI18nextProvider'
import { CustomDataLakeProvider } from './components/CustomDataLakeProvider/CustomDataLakeProvider'
import reportWebVitals from './reportWebVitals'

eventBusInit()

export const appRouter = createBrowserRouter(
  [
    {
      path: '',
      element: (
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <CustomNavigationContextProvider>
                <SvgProvider filename={sprite}>
                  <CustomDataLakeProvider>
                    <ErrorBoundaryWrapper>
                      <App />
                    </ErrorBoundaryWrapper>
                  </CustomDataLakeProvider>
                </SvgProvider>
              </CustomNavigationContextProvider>
            </PersistGate>
          </Provider>
        </QueryParamProvider>
      ),
      children: ROUTES,
    },
  ],
  {
    basename: `/learn`,
  },
)

function renderApp() {
  const container = document.getElementById('root')
  if (!container) {
    throw new Error('Root element not found')
  }

  const root = createRoot(container)

  root.render(
    <CombinedI18nextProvider>
      <ConfigLoader platform={SentryPlatforms.learner}>
        <RouterProvider router={appRouter} />
      </ConfigLoader>
    </CombinedI18nextProvider>,
  )
}

async function main() {
  renderApp()
  reportWebVitals() // Learn more: https://bit.ly/CRA-vitals
}

main()
